export default "__VITE_ASSET__909b109b__"